var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#2268FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 6H10.375C8.65188 6 7.25 7.40188 7.25 9.125V18.5C7.25 19.8787 8.37125 21 9.75 21H16.625C18.3481 21 19.75 19.5981 19.75 17.875V9.125C19.75 7.40188 18.3481 6 16.625 6ZM18.5 9.125V16H11V7.25H13.5V12.4669C13.5 12.8563 13.9944 13.0231 14.2306 12.7137L15.0625 11.6244L15.8944 12.7137C16.1306 13.0231 16.625 12.8563 16.625 12.4669V7.25C17.6588 7.25 18.5 8.09125 18.5 9.125ZM9.75 7.365V16C9.2925 16 8.86938 16.1325 8.5 16.3475V9.125C8.5 8.31125 9.02438 7.62375 9.75 7.365ZM16.625 19.75H9.75C8.10688 19.7206 8.10813 17.2788 9.75 17.25H18.5V17.875C18.5 18.9087 17.6588 19.75 16.625 19.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.4c439cbc7b9cfb5835106273e0e1bf5b.svg";
export { ForwardRef as ReactComponent };